import { Toaster } from 'sonner';

/** Global toast host — mount once in App. */
export function AppToaster() {
  return (
    <Toaster
      position="top-right"
      richColors
      closeButton
      expand={false}
      visibleToasts={4}
      toastOptions={{
        classNames: {
          toast: 'rounded-xl border shadow-card font-sans',
          title: 'text-sm font-semibold',
          description: 'text-xs opacity-90',
          closeButton: 'border-gray-200 bg-white',
        },
      }}
    />
  );
}
